<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap>
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
          <BaseCard>
      <VCardTitle>
      <span class="title font-weight-light">
        Reset password
      </span>
      </VCardTitle>

            <VContainer v-if="!reseting">
              <VFlex xs12>
                <VTextField
                        v-model="internalValue"
                        label="Enter the email or username for your account"
                        name="email"
                        outlined
                />

                <!--<BaseText>Forgot email?</BaseText>-->

                <VLayout align-center>
                  <VFlex xs8>

                  </VFlex>
                  <VFlex text-xs-right>
                    <BaseBtn
                            :disabled="!internalValue"
                            class="ma-0"
                            @click="requestReset()"
                            :loading="loading"
                    >
                      Reset
                    </BaseBtn>
                  </VFlex>
                </VLayout>
              </VFlex>
            </VContainer>
            <VContainer v-else>
              <VFlex xs12>
                Please check your email
              </VFlex>
            </VContainer>

            <VCardActions>
              <BaseBtn  text
                    class="ma-0"
                    @click="step=1"
                    to="/auth/signin"
              >
                Sign In
              </BaseBtn>
            </VCardActions>

          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>

    import BaseBtn from "../../components/BaseBtn";
    import {
      mapActions,
      mapMutations
    } from 'vuex'

    export default {
      components: {BaseBtn},
      data () {
            const data = {
              internalValue:undefined,
              verificationCode:undefined,
              newPassword:undefined,
              loading:false,
              reseting:false
            }
            return data
        },
        name: 'Recover',
        mounted(){
          let l = this.$store.getters['cognito/isLoggedIn'];
          if(l && this.$route.path.includes('auth')){
            this.$router.push('/')
          }
        },
        methods: {
          ...mapActions('cognito', ['registerUser','forgotPassword']),
          ...mapMutations(['setSnackbar']),
          requestReset(){
            let em = this;
            this.forgotPassword({
              username: this.internalValue,
              env:'dev'
            }).then(()=>{
                  em.loading=false;
                  em.$store.commit('setSnackbar',{
                    type: 'info',
                    msg: 'Check your email for a reset link',
                    timeout:6000
                  })
                  em.reseting = true;
                }).catch(err=>{
                  em.loading=false;
                  console.log(err)
                  this.setSnackbar({
                    type: 'error',
                    msg: err.message,
                    timeout: 10000
                  })
                })
              }
            // requestReset(){
            //   this.loading = true;
            //   let em = this;
            //   let args={
            //     url:em.$store.state.url + 'api/auth/requestreset',
            //     method:"POST",
            //     data:{
            //       username:this.internalValue
            //     }
            //   }
            //   this.$store.dispatch('openFetch',args).then(async res=>{
            //     em.loading=false;
            //     em.$store.commit('setSnackbar',{
            //       type: res.status,
            //       msg: res.msg,
            //       timeout:6000
            //     })
            //     em.reseting = true;
            //   }).catch(err=>{
            //     em.loading=false;
            //     console.log(err)
            //     this.setSnackbar({
            //       type: 'error',
            //       msg: err.message,
            //       timeout: 10000
            //     })
            //   })
            // }
        }
    }
</script>

